export const testimonialData = [
    {
        id: 1,
        name: "Andi Simorangkir, S.T",
        role: "Client",
        description: "Sangat puas dengan hasil integrasi Payment Gateway-nya. Prosesnya mulus, aman, dan tim support-nya sangat handal dalam membantu kendala teknis.",
        image: require("@/assets/img/client.jpg"),
        rating: 5
    },
    {
        id: 2,
        name: "Preddy Budiman, S.H",
        role: "Client",
        description: "Sistem WhatsApp Gateway yang dikembangkan sangat membantu efisiensi operasional kami. Notifikasi ke pelanggan kini jadi lebih cepat dan teratur.",
        image: require("@/assets/img/client.jpg"),
        rating: 5
    },
    {
        id: 3,
        name: "Doni Budiman, S.H",
        role: "Client",
        description: "Platform undangan digitalnya sangat elegan dan modern. Banyak tamu kami yang memuji desainnya yang interaktif dan responsif di berbagai perangkat.",
        image: require("@/assets/img/client.jpg"),
        rating: 5
    }
];
